import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class InventoryRegistryView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      columns: [],
      groups: [],

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const dArrange = [];
    const dColumns = [];

    for (let i = 1; i <= 10; i++) {
      const key = `d${i}_request`;
      dArrange.push({
        key,
        label: "req #",
        group: `d${i}`,
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      });
      dArrange.push({
        key: `${key}_percent`,
        label: "req %",
        group: `d${i}`,
        parsefunc: ({ total_request, [key]: d_request }) => {
          return total_request === 0 || d_request === "-"
            ? 0
            : d_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      });
      dColumns.push(`d${i}_request`);
    }

    const tempColumns = [
      columns[0],
      columns[1],
      "b_request",
      ...dColumns,
      "o_request",
      "x_request",
      "total_request",
    ];

    const arrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_request",
        label: "total req #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_request",
        label: "req #",
        group: "b",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_request_percent",
        label: "req %",
        group: "b",
        parsefunc: ({ b_request, total_request }) => {
          return total_request === 0 || b_request === "-"
            ? 0
            : b_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      ...dArrange,
      {
        key: "o_request",
        label: "req #",
        group: "o",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_request_percent",
        label: "req %",
        group: "o",
        parsefunc: ({ total_request, o_request }) => {
          return total_request === 0 || o_request === "-"
            ? 0
            : o_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "x_request",
        label: "req #",
        group: "x",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "x_request_percent",
        label: "req %",
        group: "x",
        parsefunc: ({ total_request, x_request }) => {
          return total_request === 0 || x_request === "-"
            ? 0
            : x_request / total_request;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const reqIdx = _.indexOf(columns, "request_v2");

    const newRecords = [];
    const keyMap = new Map();

    _.forEach(records, (item) => {
      const date = item[dateIdx];
      const id = item[idIdx];
      const group = item[groupIdx];
      const req = item[reqIdx];

      let index = keyMap.get(`${date}-${id}`);

      if (_.isNil(index)) {
        // 14 => b, d1, ... , d10, o, x, total
        const valArr = new Array(14).fill(0);
        newRecords.push([date, id, ...valArr]);
        index = newRecords.length - 1;
        keyMap.set(`${date}-${id}`, index);
      }

      if (group === "b") {
        newRecords[index][2] += req;
      } else if (group === "o") {
        newRecords[index][13] += req;
      } else if (group === "x") {
        newRecords[index][14] += req;
      } else {
        const dIdx = _.toNumber(group.replace("d", ""));
        newRecords[index][dIdx + 2] += req;
      }
      newRecords[index][15] += req;
    });

    const result = parseTableData({
      columns: tempColumns,
      arrangeColumns: arrangeCol,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      orderKey: "total_request",
    });

    this.setState({
      ...result,
      columns: arrangeCol,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      tags: arrangeCol.slice(3).map((item) => ({
        value: item.key,
        label: item.label,
        group: item.group,
      })),
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
    });

    if (result) {
      this.setState({
        ...result,
      });
    }
  }

  render() {
    const { filterAmount, filterGroups, filterRecords, columns, tags } =
      this.state;

    const header = (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={4}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d1
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d2
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d3
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d4
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d5
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d6
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d7
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d8
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d9
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          d10
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          x
        </th>
      </tr>
    );

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>
        <div className="w-full overflow-x-auto">
          <GroupDataTable
            header={header}
            records={filterRecords}
            groups={filterGroups}
            amount={filterAmount}
            mainKey="ext_gam_unit_id"
            columns={columns}
          ></GroupDataTable>
        </div>
      </>
    );
  }
}

export default InventoryRegistryView;
